export default class Hamburger {
  static exec() {
    const els = document.querySelectorAll('[data-component="hamburger"]');
        els.forEach(function (el) {
            new Hamburger(el);
        });
  }

  openState = false;

  constructor(el) {
    this.el = el;
    this.el.addEventListener('click', this.toggle.bind(this));
  }

  toggle() {
    this.openState = !this.openState;
    this.el.setAttribute('data-open', this.openState);
    this.el.dispatchEvent(new CustomEvent('state', { detail: { state: this.openState } }));
  }
}
